import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i5 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { map } from 'rxjs/internal/operators/map';
import moment from 'moment';
import * as i1 from '@angular/common/http';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';

class APIGetReceipts {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getReceiptDetails(visaType, caseType, caseId) {
        return this.httpClient
            .get(`/${visaType}/${caseType}/${caseId}/receiptInfo`)
            .pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    postGetReceipt(visatype, taskId, stepId, payload) {
        return this.httpClient.post(`/${visatype}/task/${taskId}/step/${stepId}/update`, payload).pipe(map((response) => {
            if (response.status == 200) {
                return response;
            }
        }));
    }
    postCaseStatus(recieptNumber, taskId) {
        return this.httpClient
            .post(`/casestatus/createbytaskid?recieptNumber=${recieptNumber}&taskId=${taskId}`, {})
            .pipe(map((response) => {
            if (response.status == 200) {
                return response;
            }
        }));
    }
    convertUploadDocument(Id) {
        return this.httpClient.get(`/ocr/I797/${Id}/ocrdocdetails`)
            .pipe(map((response) => {
            return response;
        }));
    }
}
APIGetReceipts.ɵfac = function APIGetReceipts_Factory(t) { return new (t || APIGetReceipts)(i0.ɵɵinject(i1.HttpClient)); };
APIGetReceipts.ɵprov = i0.ɵɵdefineInjectable({ token: APIGetReceipts, factory: APIGetReceipts.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIGetReceipts, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseGetReceiptsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.isWizard = false;
        this.observableSubscription$ = new Subject();
        this.receiptMaxDate = null;
        this.receiptDetails = {
            receiptDate: null,
            receiptNumber: '',
        };
    }
    loadInit() {
        if (!sessionStorage.getItem('wizardTID')) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 || data.isBeneficiaryAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
                this.stepDetails = data;
                this.getReceipts();
            });
        }
        else {
            this.getReceipts();
        }
    }
    afterViewInit() {
        this.getReceiptsForm.form.valueChanges.pipe(map(() => this.getReceiptsForm.dirty))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getReceipts() {
        this.apiService.getReceiptDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b;
            if (response) {
                this.receiptDetails = {
                    receiptDate: response.data && response.data.receiptDate ?
                        new Date(moment(response.data.receiptDate).format('L')) : null,
                    receiptNumber: ((_a = response.data) === null || _a === void 0 ? void 0 : _a.receiptNumber) ? (_b = response.data) === null || _b === void 0 ? void 0 : _b.receiptNumber : null,
                };
                this.toggleControlsStatus();
            }
            this.getReceiptsForm.form.markAsPristine();
        });
    }
    postGetReceipts() {
        var _a;
        const receiptPayload = {
            benchMarkActionCode: '',
            endDate: '',
            responseCode: '',
            responseNote: '',
            reviewCode: '',
            reviewNote: '',
            startDate: '',
            statusCode: (_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.stepStatusDetails.stepStatusCode,
            stepNote: '',
            isAttorneyNotify: 0,
            isBeneficiaryNotify: 0,
            isPetitionerNotify: 0,
            receiptNumber: this.receiptDetails.receiptNumber,
            receiptDate: moment(this.receiptDetails.receiptDate).format('YYYY-MM-DD'),
            receiptType: '',
            receiptCategory: ''
        };
        let visaType = this.inputData.visatype;
        if (this.inputData.caseType == 'I130') {
            visaType = this.inputData.caseType;
        }
        this.apiService.postGetReceipt(visaType, this.inputData.subTaskId, this.inputData.stepId, receiptPayload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a;
            if (response && response.status === 200) {
                //save case status
                this.saveCaseStatus();
                this.toastr.success(response.message, 'Success');
                this.getReceiptsForm.resetForm();
                if (((_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.stepStatusDetails.stepStatusCode) === 'NEW') {
                    this.updateStepStatus('INPROGRESS');
                }
                else {
                    this.getReceipts();
                }
            }
        });
    }
    saveCaseStatus() {
        this.apiService.postCaseStatus(this.receiptDetails.receiptNumber, this.inputData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    receiptNumChanged(num) {
        // console.log("receiptNumChanged",this.receiptDetails.receiptNumber,num);
        this.toggleControlsStatus();
    }
    // Toggle controls status based on step status
    toggleControlsStatus() {
        var _a, _b, _c;
        const receiptDate = this.receiptDetails.receiptDate ? moment(this.receiptDetails.receiptDate).format('YYYY-MM-DD') : null;
        this.disabledControls =
            ((_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.stepStatusDetails.stepStatusCode) === "NEW" ||
                ((_b = this.stepDetails) === null || _b === void 0 ? void 0 : _b.stepStatusDetails.stepStatusCode) === "COMPLETE" ||
                ((_c = this.stepDetails) === null || _c === void 0 ? void 0 : _c.stepStatusDetails.stepStatusCode) === "SUBMIT";
        this.fileUploadConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: false,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getApiUrl: this.inputData.caseType === 'I130' ?
                `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/RECPET` :
                `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/taskStep/${this.inputData.stepId}/category/RECPET?&taskId=${this.inputData.subTaskId}`,
            postApiUrl: this.inputData.caseType === 'I130' ?
                `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/RECPET/fileCategory/RECNOTC` :
                `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/taskStep/${this.inputData.stepId}/category/RECPET/entity/${this.receiptDetails.receiptNumber ? this.receiptDetails.receiptNumber.toUpperCase() : this.receiptDetails.receiptNumber}/fileCategory/RECNOTC?&receiptDate=${receiptDate}&taskId=${this.inputData.subTaskId}`,
            deleteApiUrl: this.inputData.caseType === 'I130' ?
                `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/` :
                `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/receipt/`,
            documentTypeDropdownCode: 'RECNOTC'
        });
    }
    handleCancel() {
        this.getReceipts();
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseGetReceiptsLibraryService.ɵfac = function BaseGetReceiptsLibraryService_Factory(t) { return new (t || BaseGetReceiptsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIGetReceipts), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DirtyFormGuard)); };
BaseGetReceiptsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseGetReceiptsLibraryService, factory: BaseGetReceiptsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseGetReceiptsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIGetReceipts }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }]; }, null); })();

/*
 * Public API Surface of base-get-receipts-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIGetReceipts, BaseGetReceiptsLibraryService };
//# sourceMappingURL=base-get-receipts-library.js.map
